import { useBookings, type Booking } from '../useBookings';
import { useDataBySlug } from './useDataBySlug';

/**
 * Hook for finding booking by short ID using the generic data by slug pattern
 */
export const useBookingByShortId = (bookingId: string) => {
  const { data: bookings = [], isLoading, error } = useBookings();

  return useDataBySlug(bookingId, {
    data: bookings,
    isLoading,
    error,
    slugExtractor: (booking) => booking.booking_id,
    queryKeyPrefix: 'booking-by-short-id',
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
};